import(/* webpackMode: "eager" */ "/home/runner/work/fanhearts.com/fanhearts.com/src/app/global-error.tsx");
